import { Box, SimpleGrid, Text } from '@chakra-ui/react';

import React, { useState } from 'react';
import cep from 'cep-promise';
// import JSEncrypt from 'node-jsencrypt'; UPDATING TODO: Verificar substituto pro node-jsencrypt se necessário (pelo q vi é usado só no moip)
// import { MoipCreditCard } from 'moip-sdk-js';

import Input from 'src/legacy/Components/Forms/Input';

import { useEventContext } from '../../provider';
import { useCheckoutFormValuesStore, useCheckoutStore } from '../../stores';
import { useParams } from 'react-router-dom';

// UPDATING TODO
// const getWirecardCardToken = (
//   sellerKey: string,
//   cardNumber: string,
//   cardCvc: string,
//   cardExpiration: string,
// ) => {
//   const separatedCardExpiration = cardExpiration.split(' / ');
//   return MoipCreditCard.setEncrypter(JSEncrypt, 'node')
//     .setPubKey(sellerKey)
//     .setCreditCard({
//       number: cardNumber,
//       cvc: cardCvc,
//       expirationMonth: separatedCardExpiration[0].trim(),
//       expirationYear: separatedCardExpiration[1]
//         ? separatedCardExpiration[1].trim().slice(-2)
//         : '',
//     })
//     .hash();
// };

const CheckoutAddCard = () => {
  const { eventID } = useParams();

  const {
    invalidFieldsNames,
    setInvalidFieldsNames,
    invalidFieldsMessage,
    setInvalidFieldsMessage,
  } = useEventContext();
  const { getEventCheckout } = useCheckoutStore();
  const { formValues, setFormValues } = useCheckoutFormValuesStore();
  const [payerCpf, setPayerCpf] = useState(
    formValues.payerBirthdate ? formValues.payerCpf : '',
  );
  const [payerPhone, setPayerPhone] = useState(
    formValues.payerBirthdate ? formValues.payerPhone : '',
  );

  if (!eventID) return null;

  const checkout = getEventCheckout(eventID);

  const onCardInfoChange = async (
    cardNumber: string,
    cardCvc: string,
    cardExpiration: string,
  ) => {
    if (checkout.mediator === 'pagarme') return;

    const cleanCardNumber = cardNumber.replace(/\s/g, '');

    if (
      [14, 15, 16].includes(cleanCardNumber.length) &&
      cardCvc &&
      cardExpiration
    ) {
      try {
        // UPDATING TODO
        // const cardToken = await getWirecardCardToken(
        //   checkout.sellerKey,
        //   cleanCardNumber,
        //   cardCvc,
        //   cardExpiration,
        // );
        // setFormValues({ cardToken });
      } catch (e) {
        setInvalidFieldsNames?.(prev => [...prev, 'cardNumber']);
        setInvalidFieldsMessage?.(prev => [
          ...prev,
          'O número do cartão não é válido',
        ]);
      }
    }
  };

  const handleOnChangeCardNumber = (cardNumber: string) => {
    setFormValues({ cardNumber });
    onCardInfoChange(cardNumber, formValues.cardCvc, formValues.cardExpiration);
  };

  const handleOnChangeCardExpiration = (cardExpiration: string) => {
    setFormValues({ cardExpiration });
    onCardInfoChange(formValues.cardNumber, formValues.cardCvc, cardExpiration);
  };

  const handleOnChangeCardCvc = (cardCvc: string) => {
    setFormValues({ cardCvc });
    onCardInfoChange(formValues.cardNumber, cardCvc, formValues.cardExpiration);
  };

  const handleOnChangeZipCode = async (payerZipCode: string) => {
    setFormValues({ payerZipCode });
    const cleanZipCode = payerZipCode.replace('-', '').replace(/\s/g, '');
    if (cleanZipCode.length === 8) {
      try {
        const res = await cep(cleanZipCode);
        setFormValues({
          payerAddress: res.street,
          payerState: res.state,
          payerCity: res.city,
          payerDistrict: res.neighborhood,
          isAddressFieldsVisible: true,
        });

        setInvalidFieldsNames?.(prev =>
          prev.filter(field => field !== 'payerZipCode'),
        );
      } catch (er) {
        setFormValues({ isAddressFieldsVisible: true });
      }
      return;
    }

    setFormValues({
      payerAddress: '',
      payerState: '',
      payerCity: '',
      payerDistrict: '',
    });

    setInvalidFieldsNames?.(prev => {
      if (!prev.includes('payerZipCode')) {
        return [...prev, 'payerZipCode'];
      } else {
        return prev;
      }
    });
  };

  const handleOnChange = (fieldName: string) => (value: unknown) => {
    setFormValues({ [fieldName]: value });
    if (fieldName === 'payerCpf') {
      setPayerCpf(value as string);
    } else if (fieldName === 'payerPhone') {
      setPayerPhone(value as string);
    }
  };

  const handleOnChangeToUpperCase = (fieldName: string) => (value: string) => {
    setFormValues({ [fieldName]: value.toUpperCase() });
  };

  return (
    <Box w="full" mx="auto" pb="8">
      <Text>
        Faremos uma pequena cobrança de até R$ 8,00 no seu cartão de crédito, em
        seguida iremos te perguntar o valor cobrado. Após confirmar o valor, seu
        cartão será verificado e a cobrança será estornada
      </Text>
      <Text p="0" pt="4" as="h2" mb="6">
        Dados do Cartão de crédito:
      </Text>
      <SimpleGrid columns={[1, 1, 2, 2]} gap="4" w="100%">
        <Box gridColumn="span 2">
          <Input
            className="inspectlet-sensitive"
            label="Número do cartão"
            format="9999 9999 9999 9999"
            type="mask"
            value={formValues.cardNumber}
            wrong={invalidFieldsNames.includes('cardNumber')}
            // @ts-ignore
            onChange={handleOnChangeCardNumber}
            customType="tel"
          />
        </Box>
        <Box gridColumn={{ base: 'span 2', sm: 'span 1' }}>
          <Input
            className="inspectlet-sensitive"
            label="CVC"
            type="mask"
            value={formValues.cardCvc}
            wrong={invalidFieldsNames.includes('cardCvc')}
            // @ts-ignore
            onChange={handleOnChangeCardCvc}
            customType="tel"
            maxLength={4} // Limita o número de caracteres a 3
          />
        </Box>
        <Box gridColumn={{ base: 'span 2', sm: 'span 1' }}>
          <Input
            className="inspectlet-sensitive"
            label="Validade"
            type="mask"
            format="99 / 9999"
            value={formValues.cardExpiration}
            wrong={invalidFieldsNames.includes('cardExpiration')}
            // @ts-ignore
            onChange={handleOnChangeCardExpiration}
            customType="tel"
          />
        </Box>
        <Text p="0" pt="4" as="h2" gridColumn="span 2">
          Dados do Titular:
        </Text>
        <Box gridColumn="span 2">
          <Input
            label="Nome (como impresso no cartão)"
            value={formValues.payerName}
            wrong={invalidFieldsNames.includes('payerName')}
            // @ts-ignore
            onChange={handleOnChangeToUpperCase('payerName')}
          />
        </Box>
        <Box gridColumn="span 2">
          <Input
            label="CPF"
            type="mask"
            format="999.999.999-99"
            value={payerCpf}
            wrong={invalidFieldsNames.includes('payerCpf')}
            // @ts-ignore
            onChange={handleOnChange('payerCpf')}
            customType="tel"
          />
        </Box>
        <Box gridColumn={{ base: 'span 2', sm: 'span 1' }}>
          <Input
            label="Telefone (com DDD)"
            type="mask"
            format="(99) 99999-9999"
            value={payerPhone}
            wrong={invalidFieldsNames.includes('payerPhone')}
            // @ts-ignore
            onChange={handleOnChange('payerPhone')}
            customType="tel"
          />
        </Box>
        <Box gridColumn={{ base: 'span 2', sm: 'span 1' }}>
          <Input
            label="Nascimento"
            type="mask"
            format="99 / 99 / 9999"
            value={formValues.payerBirthdate}
            wrong={invalidFieldsNames.includes('payerBirthdate')}
            // @ts-ignore
            onChange={handleOnChange('payerBirthdate')}
            customType="tel"
          />
        </Box>
        <Box gridColumn="span 2">
          <Input
            label="CEP"
            type="mask"
            format="99999-999"
            value={formValues.payerZipCode}
            wrong={invalidFieldsNames.includes('payerZipCode')}
            // @ts-ignore
            onChange={handleOnChangeZipCode}
            customType="tel"
          />
        </Box>
        {formValues.isAddressFieldsVisible && (
          <>
            <Box gridColumn="span 2">
              <Input
                label="Endereço"
                value={formValues.payerAddress}
                wrong={invalidFieldsNames.includes('payerAddress')}
                // @ts-ignore
                onChange={handleOnChange('payerAddress')}
              />
            </Box>
            <Box
              gridColumn="span 2"
              position="relative"
              className="address-number">
              <Input
                label="Número"
                value={formValues.payerStreetNumber}
                wrong={invalidFieldsNames.includes('payerStreetNumber')}
                // @ts-ignore
                onChange={handleOnChange('payerStreetNumber')}
                disabled={formValues.noNumber}
              />
              <Input
                type="checkbox"
                label="S/N"
                value={formValues.noNumber}
                // @ts-ignore
                onChange={handleOnChange('noNumber')}
              />
            </Box>
            <Box gridColumn="span 2">
              <Input
                label="Complemento"
                value={formValues.payerComplement}
                wrong={invalidFieldsNames.includes('payerComplement')}
                // @ts-ignore
                onChange={handleOnChange('payerComplement')}
              />
            </Box>
            <Box gridColumn="span 2">
              <Input
                label="Bairro"
                value={formValues.payerDistrict}
                wrong={invalidFieldsNames.includes('payerDistrict')}
                // @ts-ignore
                onChange={handleOnChange('payerDistrict')}
              />
            </Box>
            <Box gridColumn="span 2">
              <Input
                label="Estado"
                value={formValues.payerState}
                wrong={invalidFieldsNames.includes('payerState')}
                // @ts-ignore
                onChange={handleOnChange('payerState')}
              />
            </Box>
            <Box gridColumn="span 2">
              <Input
                label="Cidade"
                value={formValues.payerCity}
                wrong={invalidFieldsNames.includes('payerCity')}
                // @ts-ignore
                onChange={handleOnChange('payerCity')}
              />
            </Box>
          </>
        )}
      </SimpleGrid>
      {invalidFieldsMessage[0] !== '' && (
        <Text mt="4" color="red.500" textAlign="center">
          {invalidFieldsMessage[0]}
        </Text>
      )}
    </Box>
  );
};

export default CheckoutAddCard;
